import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { appPaths } from "../../shared/routing/appPaths";
import { useLoad } from "../../shared/loading/useLoad";
import CopyReference from "../../ui/content/CopyReference";
import { readCurrentItem } from "./currentItem";

/** "Replaced by" and the replacing item by name, linked at its latest version. If it can't
 * be found there, its ID stays copyable but is not shown. */
export default function ReplacementLine({ projectId, itemId }: { projectId: string | null; itemId: string }) {
  const { t } = useTranslation();
  const load = useCallback(
    (signal: AbortSignal) => (projectId === null ? Promise.resolve(null) : readCurrentItem(projectId, itemId, signal)),
    [projectId, itemId],
  );
  const { state } = useLoad(load);
  const replacement = state.status === "loaded" ? state.value : null;
  return (
    <p className="app-text-muted flex flex-wrap items-center gap-1">
      {t("reviews.lifecycle.replacedBy")}
      {replacement !== null ? (
        <>
          <Link to={appPaths.item(replacement.reference)} className="app-link underline">
            {replacement.name}
          </Link>
          <CopyReference value={replacement.reference} />
        </>
      ) : state.status === "loading" ? (
        <span>…</span>
      ) : (
        <CopyReference value={itemId} />
      )}
    </p>
  );
}
